<template>
  <div v-if="yearsDropdown && yearsDropdown.length">
    <form @submit.prevent="onSearch" class="mt-5">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <SelectVue
              v-model="filters.year"
              :options="yearsDropdown"
              :is-clear="true"
              placeholder="Year"/>
        </div>
        <div class="col-lg-2 col-sm-12 col-12">
          <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="!loading">{{ $t('general.button.search') }}</span>
            <span v-else>{{ $t('general.button.search_in_progress') }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="table-responsive  overflow-auto">
    <table class="table table-striped mt-2">
      <thead>
      <tr>
        <th>Erster Urlaubstag</th>
        <th>Letzter Urlaubstag</th>
        <th class="text-end pe-5">Verwendete Urlaubstage</th>
        <th>Typ</th>
        <th class="text-center">Jahr der verwendeten Urlaubstage</th>
        <th class="text-center">Status</th>
        <th style=" text-align: right; padding-right: 30px; min-width: 150px;">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(holiday) in holidays" :key="holiday.id"
          :style="{ backgroundColor: holiday.specialLeave ? '#e4e4e4' : '' }">
        <td>{{ holiday.startDate }}</td>
        <td>{{ holiday.endDate }}</td>
        <td class="text-end pe-5">{{ holiday.requestDays }}</td>
        <td>{{ holiday.typeTranslated }}</td>
        <td class="text-center">
          <!-- Check if holiday type is "special_leave" -->
          <strong v-if="holiday.type === 'special_leave'" class="js-lists-values-employee-name">
            Sonderurlaub
          </strong>

          <!-- If not "special_leave", check other conditions -->
          <strong v-else-if="holiday.year !== null" class="js-lists-values-employee-name">
            {{ holiday.year }}
          </strong>

          <!-- If holiday.year is null, check holiday status -->
          <strong v-else-if="holiday.status === 'approved'" class="js-lists-values-employee-name">
            {{ holiday.uniqueYearsFromItems }}
          </strong>
        </td>
        <td class="text-center">
            <span v-if="holiday.status === 'pending'">
               <span class="status-pill yellow p-2 me-2"
                     data-bs-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          <span v-if="holiday.status === 'approved'">
                <span class="status-pill green p-2 me-2"
                      data-bs-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          <span v-if="holiday.status === 'declined'">
               <span class="status-pill red p-2 me-2"
                     data-bs-toggle="tooltip" data-original-title="" title="">
               </span>
            </span>
          {{ holiday.statusTranslated }}
        </td>
        <td class="text-end">
            <span v-if="holiday.status === 'pending'">
                <span v-if="holiday.type === 'special_leave'">
                  <button class="btn btn-primary" @click="showEditSpecialLeaveModal(holiday.id)">
                        <i class="os-icon os-icon-edit"></i>
                  </button>
                </span>
                <span v-if="holiday.type === 'parental_leave'">
                  <button class="btn btn-primary" @click="showEditParentalLeaveModal(holiday.id)">
                        <i class="os-icon os-icon-edit"></i>
                  </button>
                </span>
                <span v-if="holiday.type === 'regular'">
                  <button class="btn btn-primary" @click="showEditRegularHolidayModal(holiday.id)">
                        <i class="os-icon os-icon-edit"></i>
                  </button>
                </span>

                <button class="btn btn-danger ms-2" @click="showDeleteModal(holiday?.id)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
            </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  holidays: {
    type: Array,
    required: true,
  },
  showRegularHolidayModal: {
    type: Boolean,
    required: true,
  },
  regularHolidayId: {
    type: [Number, null],
    required: true,
  },
  showSpecialLeaveModal: {
    type: Boolean,
    required: true,
  },
  specialLeaveId: {
    type: [Number, null],
    required: true,
  },
  showParentalLeaveModal: {
    type: Boolean,
    required: true,
  },
  parentalLeaveId: {
    type: [Number, null],
    required: true,
  },
  showDeleteModal: {
    type: Boolean,
    required: true,
  },
  requestIdForDeleting: {
    type: [Number, null],
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
  yearsDropdown: {
    type: [ Array, null ],
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Emit search event
const emit = defineEmits([
  'search',
  'update:showRegularHolidayModal',
  'update:regularHolidayId',
  'update:showSpecialLeaveModal',
  'update:specialLeaveId',
  'update:showParentalLeaveModal',
  'update:parentalLeaveId',
  'update:showDeleteModal',
  'update:requestIdForDeleting',
]);

const { filters }   = toRefs(props);
const yearsDropdown = toRefs(props)[ 'yearsDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function showEditRegularHolidayModal(id) {
  emit('update:showRegularHolidayModal', true);
  emit('update:regularHolidayId', id);
}

function showEditSpecialLeaveModal(id) {
  emit('update:showSpecialLeaveModal', true);
  emit('update:specialLeaveId', id);
}

function showEditParentalLeaveModal(id) {
  emit('update:showParentalLeaveModal', true);
  emit('update:parentalLeaveId', id);
}

function showDeleteModal(id) {
  emit('update:showDeleteModal', true);
  emit('update:requestIdForDeleting', id);
}
</script>
